"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _Output = _interopRequireDefault(require("./Output"));

var _NewOutput = _interopRequireDefault(require("./NewOutput"));

var _OutputSection = _interopRequireDefault(require("./OutputSection"));

var _newOutput = _interopRequireDefault(require("../../../../../common/constants/newOutput"));

require("../styles/_outputs-and-addons.scss");

var _ResizableColumnContainer = _interopRequireDefault(require("../../../components/ResizableColumnContainer"));

var _Footer = _interopRequireDefault(require("../../../components/Footer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function scrollToNewestOutput(outputs) {
  var outputId = outputs.slice(-1)[0].outputId;
  var newOutput = document.querySelector("#output-".concat(outputId));
  var scrollable = document.querySelector('.outputs-and-addons');

  if (!scrollable || !newOutput) {
    return;
  }

  var topValue = newOutput.getBoundingClientRect().top + scrollable.scrollTop;
  scrollable.scroll({
    top: topValue,
    behavior: 'smooth'
  });
}

var OutputsAndAddons = /*#__PURE__*/function (_Component) {
  _inherits(OutputsAndAddons, _Component);

  var _super = _createSuper(OutputsAndAddons);

  function OutputsAndAddons(_ref) {
    var _this;

    var _outputs = _ref.video.outputs;

    _classCallCheck(this, OutputsAndAddons);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onSave", (0, _lodash.default)(function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          shouldContinue = _ref2.shouldContinue;

      return (/*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _this$props, goToNextStage, onSaveOutputs, hasUpdatePermission, outputs, _yield$onSaveOutputs, error;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this$props = _this.props, goToNextStage = _this$props.goToNextStage, onSaveOutputs = _this$props.onSaveOutputs, hasUpdatePermission = _this$props.hasUpdatePermission;
                  outputs = _this.state.outputs;

                  if (hasUpdatePermission) {
                    _context.next = 4;
                    break;
                  }

                  return _context.abrupt("return", void goToNextStage());

                case 4:
                  _context.next = 6;
                  return onSaveOutputs(outputs);

                case 6:
                  _yield$onSaveOutputs = _context.sent;
                  error = _yield$onSaveOutputs.error;

                  if (!(error || !shouldContinue)) {
                    _context.next = 10;
                    break;
                  }

                  return _context.abrupt("return");

                case 10:
                  goToNextStage();

                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      );
    }));

    _defineProperty(_assertThisInitialized(_this), "mergeAddon", function (outputId, addonType, addonValue) {
      var outputs = _this.state.outputs;
      var outputIndex = outputs.findIndex(function (output) {
        return output.outputId === outputId;
      });
      var existingOutput = outputs[outputIndex];
      var version = existingOutput.versions[0];
      var existingAddon = version.appliedAddons[addonType] || {};

      var _version$appliedAddon = version.appliedAddons,
          removedAddon = _version$appliedAddon[addonType],
          remainingAddons = _objectWithoutProperties(_version$appliedAddon, [addonType].map(_toPropertyKey)); // If there's no addon value, remove the addon on completely. null is treated differently as
      // 'resetting' the value


      var newAddons = addonValue === void 0 ? remainingAddons : _objectSpread({}, version.appliedAddons, _defineProperty({}, addonType, addonValue && !Array.isArray(addonValue) ? _objectSpread({}, existingAddon, {
        value: addonValue
      }) : addonValue));

      var newVersion = _objectSpread({}, version, {
        appliedAddons: newAddons
      });

      var newOutput = _objectSpread({}, existingOutput, {
        versions: [newVersion]
      });

      var newOutputs = _toConsumableArray(outputs);

      newOutputs.splice(outputIndex, 1, newOutput);

      _this.setState({
        outputs: newOutputs
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeAddon", function (outputId) {
      return function (field) {
        return function (_ref4) {
          var value = _ref4.value;

          if (field === 'aspectRatio') {
            var outputs = _this.state.outputs;
            var outputIndex = outputs.findIndex(function (output) {
              return output.outputId === outputId;
            });

            var newOutput = _objectSpread({}, outputs[outputIndex], {
              aspectRatio: value
            });

            var newOutputs = _toConsumableArray(outputs);

            newOutputs.splice(outputIndex, 1, newOutput);
            return void _this.setState({
              outputs: newOutputs
            });
          }

          _this.mergeAddon(outputId, field, value);
        };
      };
    });

    _defineProperty(_assertThisInitialized(_this), "updateOutputName", function (outputId) {
      return function (_ref5) {
        var value = _ref5.target.value;
        var outputs = _this.state.outputs;
        var outputIndex = outputs.findIndex(function (output) {
          return output.outputId === outputId;
        });

        var newOutput = _objectSpread({}, outputs[outputIndex], {
          name: value
        });

        var newOutputs = _toConsumableArray(outputs);

        newOutputs.splice(outputIndex, 1, newOutput);
        return void _this.setState({
          outputs: newOutputs
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "addSrt", function (outputId) {
      return function () {
        var outputs = _this.state.outputs;
        var outputIndex = outputs.findIndex(function (output) {
          return output.outputId === outputId;
        });
        var existingOutput = outputs[outputIndex];
        var version = existingOutput.versions[0];

        var newSRTs = _toConsumableArray(version.appliedAddons.SRT_CAPTIONS || []);

        newSRTs.push({
          value: null
        });

        _this.mergeAddon(outputId, 'SRT_CAPTIONS', newSRTs);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "updateSrt", function (outputId) {
      return function (index) {
        return function () {
          var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              value = _ref6.value;

          var outputs = _this.state.outputs;
          var outputIndex = outputs.findIndex(function (output) {
            return output.outputId === outputId;
          });
          var existingOutput = outputs[outputIndex];
          var version = existingOutput.versions[0];

          if (!version.appliedAddons.SRT_CAPTIONS) {
            return;
          }

          var newSRTs = _toConsumableArray(version.appliedAddons.SRT_CAPTIONS);

          if (value) {
            // update
            newSRTs.splice(index, 1, {
              value: value
            });
          } else {
            // delete
            newSRTs.splice(index, 1);
          }

          _this.mergeAddon(outputId, 'SRT_CAPTIONS', newSRTs.length ? newSRTs : void 0);
        };
      };
    });

    _defineProperty(_assertThisInitialized(_this), "createNewOutput", function () {
      var currentOutputs = _this.state.outputs;
      var video = _this.props.video;
      var newOutputs = [].concat(_toConsumableArray(currentOutputs), [(0, _newOutput.default)({
        defaultAspectRatio: currentOutputs[0].aspectRatio,
        defaultDuration: (0, _lodash2.default)(currentOutputs[0], 'versions[0].appliedAddons.DURATION.value'),
        video: video
      })]);

      _this.setState({
        outputs: newOutputs
      }, function () {
        var outputs = _this.state.outputs;
        scrollToNewestOutput(outputs);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "deleteOutput", function (index) {
      return function () {
        var outputs = _this.state.outputs;

        var newOutputs = _toConsumableArray(outputs); // Master is at 0, so we count from 1


        newOutputs.splice(index + 1, 1);

        _this.setState({
          outputs: newOutputs
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "haveAllOutputsNotes", function (outputs) {
      return outputs.every(function (output) {
        return output.notes;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleNotesChange", function (outputId, notes) {
      _this.setState(function (_ref7) {
        var prevOutputs = _ref7.outputs;
        var outputs = prevOutputs.map(function (item) {
          if (item.outputId === outputId) {
            return _objectSpread({}, item, {
              notes: notes
            });
          }

          return item;
        });
        return {
          outputs: outputs
        };
      });
    });

    _this.state = {
      outputs: _outputs
    };
    return _this;
  }

  _createClass(OutputsAndAddons, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var outputs = this.state.outputs;
      var _this$props2 = this.props,
          goBack = _this$props2.goBack,
          _this$props2$video = _this$props2.video,
          assets = _this$props2$video.assetIds,
          videoName = _this$props2$video.name,
          hasUpdatePermission = _this$props2.hasUpdatePermission,
          shouldShowPendingApprovalInformation = _this$props2.shouldShowPendingApprovalInformation,
          shouldShowPendingApprovalButtons = _this$props2.shouldShowPendingApprovalButtons;
      var masterOutputIndex = outputs.findIndex(function (output) {
        return output.isMaster;
      });
      var masterOutput = outputs[masterOutputIndex];
      var canUpdateMaster = hasUpdatePermission && masterOutput.status.name === 'DRAFT';

      var additionalOutputs = _toConsumableArray(outputs);

      additionalOutputs.splice(masterOutputIndex, 1);
      return (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasUpdatePermission ? /*#__PURE__*/_react.default.createElement(_commonReact.Autosave, {
          data: outputs,
          functionToCall: this.onSave()
        }) : null, /*#__PURE__*/_react.default.createElement("div", {
          className: "outputs-and-addons"
        }, /*#__PURE__*/_react.default.createElement(_ResizableColumnContainer.default, {
          leftProps: {
            title: 'Outputs & Add-Ons',
            icon: 'package'
          },
          preventResize: true,
          className: "column"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "outputs-and-addons__inner"
        }, /*#__PURE__*/_react.default.createElement(_OutputSection.default, {
          title: "MASTER OUTPUT",
          icon: "master",
          iconColour: "dandelion"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "outputs-and-addons__section__block"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "outputs-and-addons__section__block__title"
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
          className: "outputs-and-addons__section__block__title__input",
          defaultValue: (0, _getVideoOutputName.default)(masterOutput, videoName),
          disabled: true
        })), /*#__PURE__*/_react.default.createElement(_Output.default, _extends({}, masterOutput, {
          onNotesChange: this.handleNotesChange,
          onChangeAddon: this.onChangeAddon(masterOutput.outputId),
          addSrt: this.addSrt(masterOutput.outputId),
          updateSrt: this.updateSrt(masterOutput.outputId),
          assets: assets,
          canUpdateOutput: canUpdateMaster
        })))), /*#__PURE__*/_react.default.createElement(_OutputSection.default, {
          title: "ADDITIONAL OUTPUTS",
          subtitle: "The master output needs to be approved and signed off before any work can be done on any other additional outputs."
        }, additionalOutputs.map(function (output, index) {
          var canUpdateOutput = hasUpdatePermission && (output.status.name === 'DRAFT' || output.status.name === 'PENDING_MASTER');
          return (/*#__PURE__*/_react.default.createElement("div", {
              className: "outputs-and-addons__section__block",
              id: "output-".concat(output.outputId),
              key: output.outputId
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "outputs-and-addons__section__block__title"
            }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
              className: "outputs-and-addons__section__block__title__input",
              placeholder: "Output name",
              defaultValue: output.name || "OUTPUT ".concat(index + 1),
              onChange: _this2.updateOutputName(output.outputId),
              disabled: !hasUpdatePermission
            }), canUpdateOutput ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
              name: "trash",
              hoverColor: "redApple",
              color: "regent",
              size: 20,
              onClick: _this2.deleteOutput(index)
            }) : null), /*#__PURE__*/_react.default.createElement(_Output.default, _extends({}, output, {
              onNotesChange: _this2.handleNotesChange,
              onChangeAddon: _this2.onChangeAddon(output.outputId),
              addSrt: _this2.addSrt(output.outputId),
              updateSrt: _this2.updateSrt(output.outputId),
              assets: assets,
              canUpdateOutput: canUpdateOutput
            })))
          );
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "outputs-and-addons__section__block"
        }, hasUpdatePermission ? /*#__PURE__*/_react.default.createElement(_NewOutput.default, {
          onClick: this.createNewOutput
        }) : null)), /*#__PURE__*/_react.default.createElement("p", {
          className: "outputs-and-addons__disclaimer"
        }, "* Subject to availability and HUB review. ** Included as part of your", ' ', /*#__PURE__*/_react.default.createElement("a", {
          href: "/organisation/manage-subscription",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "Subscription Package"))))), /*#__PURE__*/_react.default.createElement(_Footer.default, {
          buttonText: hasUpdatePermission ? 'SAVE & CONTINUE' : 'CONTINUE',
          onBackClick: goBack,
          onNext: this.onSave({
            shouldContinue: true
          }),
          showBriefInformation: !shouldShowPendingApprovalInformation && !shouldShowPendingApprovalButtons
        }))
      );
    }
  }]);

  return OutputsAndAddons;
}(_react.Component);

exports.default = OutputsAndAddons;